<template>
    <form-container header="Unvanlar" v-on:save="save" :disabled="loading">
        <div class="row">
            <div class="col col-limit">
                <div class="form-group">
                    <label>{{translate('titleName')}}</label>
                    <input @input="checkInput('Name',$event)" v-model="data.Name" type="text" class="form-control" required />
                </div>
                <div class="form-group">
                    <label>
                        <input type="checkbox" v-model="data.IsActive" />
                        {{translate('titleActive')}}
                    </label>
                </div>
            </div>
        </div>
        <template v-slot:footer>
            <div class="row">
                <div class="col"> 
                    <div class="row">
                        <div class="col">
                            <button type="button" accesskey="g" v-on:click="goBack" class="btn btn-outline-primary">{{translate('goBack')}}</button>
                        </div>
                        <div class="col text-right">
                            <button type="submit" accesskey="k" class="btn btn-success">{{translate('save')}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </form-container>
    
</template>

<script>
import formMixin from '../formMixin.js';
import formContainer from '../components/FormContainer.vue'



export default {
    mixins: [formMixin],
    components: {
        formContainer,
    },
    
    created(){
        this.getData(this.$route.params.id, true, this.$route.query.kind);
    },
    data() {
        return {
            loading: false,
            modelName: 'Title',
            data: {},
        }
    },
    methods: {
        checkInput(value, event) {
            // Check for invalid characters
            if (/[<>]/.test(event.target.value)) {
                alert(this.translate('errors.invalidSymbols'))
                const editedText = ""
                this.$set(this.data, value, editedText)
            } else {
                this.$set(this.data, value, event.target.value)
            }
        },
    }
}
</script>